import {Condition} from "../engine/Condition";
import {onPageAccess} from "../../../utils/onPageAccess";
import {merchantBuiltinVariables} from "../../merchant-state/Builtins";
import {testPath} from "./PathCondition";
import {updatePageVisit} from "./Helpers.js";

const PAGE_VISIT_ACTIVATION_TYPE = {
    atLeast: "atLeast",  // default.
    exact: "exact",
    atMost: "atMost",
};

function shouldActivate(numVisits, expectedNumVisits, activationType) {
    if (activationType === PAGE_VISIT_ACTIVATION_TYPE.exact) {
        return numVisits === expectedNumVisits;
    }
    if (activationType === PAGE_VISIT_ACTIVATION_TYPE.atMost) {
        return numVisits <= expectedNumVisits;
    }
    return numVisits >= expectedNumVisits;
}

function shouldSaveResult(result, activationType) {
    if (activationType === PAGE_VISIT_ACTIVATION_TYPE.exact) {
        return true;
    }
    if (activationType === PAGE_VISIT_ACTIVATION_TYPE.atMost) {
        return result === true;
    }
    return result === false;
}

/** @property {{
 *      numPages: number|undefined,
 *      scope: string|undefined,
 *      pathInclude: string|string[]|undefined,
 *      pathExclude: string|string[]|undefined,
 *      pathOneOf: string|string[]|undefined,
 *      timeWindow: number|undefined,
 *      filterFunction: string|Array|undefined,
 *      activationType: string|undefined,
 *  }} options */
export class NthPageVisitCondition extends Condition {
    constructor(...args) {
        super(...args);

        const {
            numPages = 1,
            activationType = PAGE_VISIT_ACTIVATION_TYPE.atLeast,
            scope = this.journey.alias,
            timeWindow,
        } = this.options;

        onPageAccess((href) => {
            const currentPath = (new URL(href)).pathname;
            const [currentVisit, pageVisitsMap] = updatePageVisit(href, {
                [scope]: this.testPath(currentPath),
            });

            let numCountedVisits;
            const cachedNumCountedVisitsKey = "numVisits." + scope;
            if (currentVisit.hasOwnProperty(cachedNumCountedVisitsKey)) {
                numCountedVisits = currentVisit[cachedNumCountedVisitsKey];
            } else {
                const oldestAllowedTimestamp = timeWindow ? Date.now() - timeWindow * 1000 : -Infinity;
                numCountedVisits = [...pageVisitsMap.values()].filter(
                    visit => (visit.lastVisit >= oldestAllowedTimestamp && visit[scope])
                ).length;
            }
            Object.assign(merchantBuiltinVariables, {
                [scope + ".count"]: numCountedVisits,
            });
            this.cachedResult = shouldActivate(numCountedVisits, numPages, activationType) && this.testPath(location.pathname);
            if (shouldSaveResult(this.cachedResult, activationType)) {
                updatePageVisit(href, {
                    [cachedNumCountedVisitsKey]: numCountedVisits,
                });
            }
            this.requestReEval();
        });
    }

    testPath(path) {
        return testPath(path,
            this.options.pathInclude,
            this.options.pathExclude,
            this.options.pathOneOf,
            this.options.filterFunction);
    }

    evaluate() {
        return this.cachedResult;
    }
}
